import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router"
import StudentLogin from "../pages/Authentication/StudentLogin.vue"
import TeacherLogin from "../pages/Authentication/TeacherLogin.vue"
import Study from "../pages/Main/Study.vue"
import { useAuthStore } from "../stores"
import { RouteName } from "../types/router"
import { useSettingStore } from "../stores/setting"

const routes: Array<RouteRecordRaw> = [
    {
        path: '/',
        name: RouteName.login,
        component: StudentLogin,
    },
    {
        path: '/teacher',
        name: RouteName.teacher_login,
        component: TeacherLogin,
    },
    {
        path: '/study',
        name: RouteName.study,
        component: Study,
        meta: { requiresAuth: true }
    }
]

const router = createRouter({
    history: createWebHistory(),
    routes
})

router.beforeEach(to => {
    // check app version on each page navigation
    const setting = useSettingStore()
    setting.getVersion()

    // guard unauthorized page request
    const auth = useAuthStore()
    if (!auth.isAuthenticated && to.meta.requiresAuth) {
        return { name: RouteName.login }
    }

    // redirect logged in user
    if (auth.isAuthenticated && (to.name === RouteName.login || to.name === RouteName.teacher_login)) {
        return { name: RouteName.study }
    }
})

export default router